import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import type { User } from 'firebase/auth';
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  addDoc,
  onSnapshot,
  Timestamp,
  serverTimestamp
} from 'firebase/firestore';

// Firebase configuration from environment variables
// Note: FIRESTORE_PROJECT_ID allows staging to connect to production database
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'adriftchatbotv3.firebaseapp.com',
  projectId: process.env.REACT_APP_FIRESTORE_PROJECT_ID || 
             process.env.REACT_APP_FIREBASE_PROJECT_ID || 'adriftchatbotv3',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'adriftchatbotv3.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ''
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(app);

// Initialize Firestore
const db = getFirestore(app);

// Export Auth functions
export {
  auth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  db,
  collection,
  doc,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  addDoc,
  onSnapshot,
  Timestamp,
  serverTimestamp
};

// Export types
export type { User };
